import React, { forwardRef } from 'react';
import {useEffect, useState} from "react";
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

const CountdownButton = forwardRef((props, ref) => {

  const { text, initCounter, interval, handler, helperText, ...rest } = props;
  const [counter, setCounter] = useState(initCounter || 0);


  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  const handleClick = () => {
    setCounter(interval || 60);
    handler();
  }

  return (
    <Tooltip
      title={`${helperText} ${counter === 0 ? 'now' : `in ${counter} seconds`}`}
      placement="top"
      {...rest}
    >
      <span>
        <Button
          disabled={counter > 0}
          onClick={handleClick}
          ref={ref}
          {...props}
        >
          {text}
        </Button>
      </span>
    </Tooltip>
  )
})

CountdownButton.displayName = 'CountdownButton';
export default CountdownButton;